<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">Assigned Service Usage Detail</h3>
      </div>
      <div class="box-body">
        <div class="row" style="margin-bottom: 15px;">
          <div class="col-sm-12">
            <b>Service {{service.servicecode}}</b><br>
            <br>
            <b>Service Name:</b> {{service.name}}<br>
            <b>Date From:</b> {{assigninfo.date_from}}<br>
            <b>Date To:</b> {{assigninfo.date_to}}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <!-- Custom Tabs -->
            <div class="nav-tabs-custom">
              <ul class="nav nav-tabs">
                <li class="active"><a href="#tab_device" data-toggle="tab">Device</a></li>
                <li><a href="#tab_installment" data-toggle="tab">Installment</a></li>
                <li><a href="#tab_history" data-toggle="tab">History</a></li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="tab_device">
                  <b-table :items="device_items" :fields="device_fields" class="mt-3" outlined>
                    
                  </b-table>
                </div>
                <!-- /.tab-pane -->
                <div class="tab-pane" id="tab_installment">
                  <b-table :items="installment_items" :fields="installment_fields" class="mt-3" outlined>
                    <template slot="status" slot-scope="row">
                      <span class="label label-success" v-if="row.value === 'paid'">Paid</span>
                      <span class="label label-warning" v-else-if="row.value === 'open'">Open</span>
                      <span class="label label-primary" v-else-if="row.value === 'issued'">Issued</span>
                    </template>
                  </b-table>
                </div>
                <!-- /.tab-pane -->
                <div class="tab-pane" id="tab_history">
                  <div class="tab-pane active" id="tab_device">
                    <b-table :items="history_items" :fields="history_fields" class="mt-3" outlined>
                    </b-table>
                  </div>
                </div>
                <!-- /.tab-pane -->
              </div>
              <!-- /.tab-content -->
            </div>
            <!-- nav-tabs-custom -->
          </div>
          <!-- /.col -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import utils from '@/lib/utils'

export default {
  name: 'ServiceUserDetail',
  data() {
    return {
      service: {},
      assigninfo: {},
      device_items: [],
      device_fields: [
        { key: 'name', label: 'Name', sortable: true, sortDirection: 'desc' },
        { key: 'type', label: 'Type', sortable: true, class: 'text-center' },
        { key: 'price', label: 'Price', sortable: true, class: 'text-center' },
        { key: 'price_depreciation', label: 'Price Depreciation', sortable: true, class: 'text-center' }
      ],
      installment_items: [],
      installment_fields: [
        { key: 'date_from', label: 'Date From', sortable: true, class: 'text-center' },
        { key: 'date_to', label: 'Date To', sortable: true, class: 'text-center' },
        { key: 'last_value', label: 'Last Value', sortable: true, class: 'text-center' },
        { key: 'current_value', label: 'Current Value', sortable: true, class: 'text-center' },
        { key: 'total_fee', label: 'Total Fee', sortable: true, class: 'text-center' },
        { key: 'status', label: 'Status', class: 'text-center' },
        { key: 'invoice', label: 'Invoice', class: 'text-center' }
      ],
      history_items: [],
      history_fields: [
        { key: 'no', label: '#', sortable: true, sortDirection: 'desc' },
        { key: 'action', label: 'Action', sortable: true, class: 'text-center' },
        { key: 'by', label: 'By', sortable: true, class: 'text-center' },
        { key: 'app', label: 'App', sortable: true, class: 'text-center' },
        { key: 'date_time', label: 'Date Time', sortable: true, class: 'text-center' }
      ]
    }
  },
  computed: {
    // ...mapGetters([
    //         // "GET_SNACK_BAR",
    //         "PAGINATION",
    //         "PAGINATOR",
    //         "PAGE_ARROW",
    //         "SERVICE_HISTORY_DATA"
    //         ]),
  },
  methods: {
    ...mapActions([
      "GET_ASSIGN_SERVICE_DETAIL",
      "GET_PROPERTY_DETAIL",
      "GET_USAGE_SERVICE_INSTALLMENT",
      "GET_SERVICE_DETAILS"
    ]),
  },
  components: {
  },
  mounted() {
    const serviceuserid = this.$route.params.serviceuserId
    this.GET_ASSIGN_SERVICE_DETAIL({id: serviceuserid}).then(
      function(res) {
        let result = res.data
        let devicesuser = result.propertyinservices
        this.assigninfo = {
          date_from: utils.formatSqlDate(result.date_from, null, "DD-MMM-YYYY"),
          date_to: utils.formatSqlDate(result.date_to, null, "DD-MMM-YYYY", "Forever")
        }
        const deviceuser = devicesuser[0]
        this.GET_PROPERTY_DETAIL({id: deviceuser.prop}).then(
          function(res) {
            let type = res.property_type === 1 ? 'Electric' : 'Water'
            let device_items = []
            let item = {
              name: res.name,
              type: type,
              price: res.price,
              price_depreciation: res.price_depreciation
            }
            device_items.push(item)
            this.device_items = device_items
          }.bind(this)
        )

        const payload = {
          serviceid: result.service,
          userid: result.user
        }
        this.GET_USAGE_SERVICE_INSTALLMENT(payload).then(
          function(res) {
            let installment_items = []
            let result = res.data.response
            result.forEach(v => {
              let status = "open"
              if (v.status === 2) {
                status = "issued"
              } else if (v.status === 3) {
                status = "paid"
              }
              let item = {
                date_from: utils.formatSqlDate(v.date_from, null, "DD-MMM-YYYY"),
                date_to: utils.formatSqlDate(v.date_to, null, "DD-MMM-YYYY", "Forever"),
                last_value: v.last_month_value,
                current_value: v.this_month_value,
                total_fee: v.total_fees,
                status: status,
                invoice: v.invoice_number
              }
              installment_items.push(item)
            })
            this.installment_items = installment_items
          }.bind(this)
        )

        // history
        let histories = result.assignedservicehistory
        let history_items = []
        histories.forEach((v, i) => {
          let history_item = {
            'no': i,
            'action': v.action,
            'by': `${v.user_created} - ${v.user_created_details.first_name} ${v.user_created_details.last_name}`,
            'app': v.app === 1 ? 'CONASI Webadmin' : 'CONASI Mobile App',
            'date_time': utils.formatSqlDate(v.date_created, null, "DD-MMM-YYYY")
          }
          history_items.push(history_item)
        })
        this.history_items = history_items

        // service detail
        const serviceid = result.service
        this.GET_SERVICE_DETAILS({id: serviceid}).then(
          function(res) {
            this.service = res
          }.bind(this)
        )

      }.bind(this)
    )
  }
}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Service/ServiceUserDetail.vue